import ReactPixel from 'react-facebook-pixel';

export const reactPixel = ReactPixel;
